export default __webpack_public_path__ + "static/media/jimena.9c5ef1a2.webp";